import { RNG } from "rot-js";
import { Point } from "../../../engine/space/bounds";
import { BasicMap } from "../BasicMap";
import { FloorTypes } from "../Map";

const OPEN_AMOUNT = 0.72;
const NUM_PASSES = 5;

const countAdjacent = (map: BasicMap, x: number, y: number) => {
  let count = 0;
  for (let i = y - 1; i < y + 2; i++) {
    for (let j = x - 1; j < x + 2; j++) {
      if ((j !== x || i !== y) && map.tileAt(j, i)?.type === FloorTypes.EMPTY) {
        count += 1;
      }
    }
  }
  return count;
};

export const cavernGenerate = (rng: typeof RNG, map: BasicMap) => {
  //Initial Seeding
  for (let y = 1; y < map.height - 1; y++) {
    for (let x = 1; x < map.width - 1; x++) {
      map.tileAt(x, y).type =
        RNG.getUniform() < OPEN_AMOUNT ? FloorTypes.EMPTY : FloorTypes.OOB;
    }
  }

  let tile, count;
  for (let i = 0; i < NUM_PASSES; i++) {
    for (let y = 0; y < map.height; y++) {
      for (let x = 0; x < map.width; x++) {
        tile = map.tileAt(x, y);
        count = countAdjacent(map, x, y);
        if (tile.type === FloorTypes.EMPTY && count < 4) {
          tile.type = FloorTypes.OOB;
        } else if (tile.type === FloorTypes.OOB && 6 <= count) {
          tile.type = FloorTypes.EMPTY;
        }
      }
    }
  }
  const rooms = buildRooms(map);

  let max = -1;
  let biggest: Point[];
  rooms.forEach((room) => {
    if (max < room.length) {
      max = room.length;
      biggest = room;
    }
  });

  rooms.forEach((room) => {
    if (room !== biggest) {
      room.forEach(({ x, y }) => {
        tile = map.tileAt(x, y);
        tile.room = -1;
        tile.type = FloorTypes.OOB;
      });
    }
  });

  for (let y = 0; y < map.height; y++) {
    for (let x = 0; x < map.width; x++) {
      tile = map.tileAt(x, y);
      if (tile.type === FloorTypes.OOB) {
        if (countAdjacent(map, x, y)) {
          tile.type = FloorTypes.WALL;
        }
      }
    }
  }
};

const buildRooms = (map: BasicMap) => {
  const rooms: Point[][] = [];

  let tile, west, north;
  for (let y = 0; y < map.height; y++) {
    for (let x = 0; x < map.width; x++) {
      tile = map.tileAt(x, y);
      if (tile?.type == FloorTypes.EMPTY) {
        west = map.tileAt(x - 1, y);
        north = map.tileAt(x, y - 1);

        if (0 < west?.room) {
          if (0 < north?.room && west.room !== north.room) {
            //merge rooms
            let lesser: number;
            let greater: number;
            if (west.room < north.room) {
              lesser = west.room;
              greater = north.room;
            } else {
              lesser = north.room;
              greater = west.room;
            }

            rooms[greater].forEach(({ x, y }) => {
              map.tileAt(x, y).room = lesser;
            });
            rooms[lesser].push(...rooms[greater]);
            rooms[greater] = [];
          } else {
            tile.room = west.room;
            rooms[west.room].push({ x, y });
          }
        } else if (0 < north?.room) {
          tile.room = north.room;
          rooms[north.room].push({ x, y });
        } else {
          const index = rooms.push([{ x, y }]);
          tile.room = index - 1;
        }
      }
    }
  }

  return rooms;
};
